/**
 * Типизированный клиент поверх axios-инстанса (@/api/axios).
 * Сохраняет поведение существующих интерцепторов (токен, Accept-Language, Sentry),
 * добавляя строгие типы запросов/ответов и мета-данные для логирования.
 */
import axiosInstance from '@/api/axios'

export interface RequestMeta {
  title?: string
  page?: string
  func?: string
  kiosk?: Record<string, unknown>
  [key: string]: unknown
}

export interface RequestConfig {
  skipLogging?: boolean
  meta?: RequestMeta
  headers?: Record<string, string>
}

interface AxiosResponseLike<T> {
  data: T
  status: number
  [key: string]: unknown
}

async function unwrap<T>(promise: Promise<AxiosResponseLike<T>>): Promise<T> {
  const response = await promise
  return response.data
}

export function apiGet<T>(url: string, config?: RequestConfig): Promise<T> {
  return unwrap<T>(axiosInstance.get(url, config))
}

export function apiPost<T>(url: string, data?: unknown, config?: RequestConfig): Promise<T> {
  return unwrap<T>(axiosInstance.post(url, data, config))
}

export function apiPut<T>(url: string, data?: unknown, config?: RequestConfig): Promise<T> {
  return unwrap<T>(axiosInstance.put(url, data, config))
}

export function apiPatch<T>(url: string, data?: unknown, config?: RequestConfig): Promise<T> {
  return unwrap<T>(axiosInstance.patch(url, data, config))
}

export function apiDelete<T>(url: string, config?: RequestConfig): Promise<T> {
  return unwrap<T>(axiosInstance.delete(url, config))
}